<template>
	<div class="release">
		<el-form ref="form" :model="form" label-width="80px" :rules="rules">
			<el-form-item label="版本号">
				<el-input v-model="form.version"></el-input>
			</el-form-item>
			<el-form-item label="是否通知">
				<el-radio-group v-model="form.sendtype">
					<el-radio label="0">通知</el-radio>
					<el-radio label="1">不通知</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="发布内容">
				<el-input
					type="textarea"
					v-model="form.remark"
					:autosize="{ minRows: 10, maxRows: 20 }"
				></el-input>
			</el-form-item>
			<el-form-item>
				<span style="display: block; text-align:right;">
					<el-button @click="close" size="mini">关闭</el-button>
					<el-button
						type="primary"
						@click="submitForm('form')"
						size="mini"
						>提交</el-button
					>
				</span>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { tagviewsMixins } from "utils/mixins";
export default {
	mixins: [tagviewsMixins],
	data() {
		return {
			form: {
				version: "",
				sendtype: "",
				remark: "",
			},
			rules: {
				version: [
					{
						required: true,
						message: "请输入版本号",
						trigger: "blur",
					},
				],
				sendtype: [
					{
						required: true,
						message: "请选择是否发送通知",
						trigger: "change",
					},
				],
				remark: [
					{
						required: true,
						message: "请输入版本内容",
						trigger: "blur",
					},
				],
			},
		};
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.onSubmit();
				} else {
					// console.log("error submit!!");
					return false;
				}
			});
		},
		onSubmit() {
			this.$api
				.ocsAddVersion({
					...this.form,
				})
				.then((response) => {
					if (response.errcode !== 0) return;
                    this.$message.success("发布成功！")
					this.close();
				});
		},
		close() {
			this.resetForm("form");
			this.$store.dispatch("tagsView/delView", this.$route);
			this.$router.go(-1);
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
	},
};
</script>

<style lang="scss" scoped>
.release {
	font-size: 14px;
	height: 100%;
	overflow: scroll;
	padding: 40px 20px;
}
</style>